import { render, staticRenderFns } from "./OneOffReasons.vue?vue&type=template&id=38ad3964&"
import script from "./OneOffReasons.vue?vue&type=script&lang=js&"
export * from "./OneOffReasons.vue?vue&type=script&lang=js&"
import style0 from "./OneOffReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports